import Vue from 'vue'
import $ from 'jQuery'

/*
  how to use:
    v-gl-focus-click="'.className'"
*/
Vue.directive('gl-focus-click', {
  // on insert
  inserted (el, binding) {
    // on click -> focus requested value
    $(el).on('click', () => {
      $(binding.value).focus()
    })
  }
})



// WEBPACK FOOTER //
// ./src/directives/gl-focus-click.js